import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyleEditorHeader } from "./StyleEditorHeader.js";
import { StyleEditorFooter } from "./StyleEditorFooter.js";
const shellStyles = `
.mapka-style-editor-shell {
  display: grid;
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
  background-color: light-dark(#F8F8F5, #272A2A);
}
.mapka-style-editor-shell-header {
  grid-area: header;
}
.mapka-style-editor-shell-main {
  grid-area: main;
  overflow: hidden;
}
.mapka-style-editor-shell-footer {
  grid-area: footer;
  border-top: 2px solid light-dark(black, white);
}
@media (min-width: 36em) {
  .mapka-style-editor-shell {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: "header" "main";
  }
  .mapka-style-editor-shell-footer { display: none; }
}
@media (max-width: 36em) {
  .mapka-style-editor-shell {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "header" "main" "footer";
  }
}

.mapka-style-editor-desktop-only { display: none; }
@media (min-width: 36em) {
  .mapka-style-editor-desktop-only { display: flex; }
}
.mapka-style-editor-mobile-only { display: flex; }
@media (min-width: 36em) {
  .mapka-style-editor-mobile-only { display: none; }
}

.mapka-style-editor-footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
  min-height: 72px;
}
.mapka-style-editor-footer-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  border: none;
  background: none;
  padding: 4px 8px;
}
.mapka-style-editor-footer-tab:hover {
  color: light-dark(var(--mantine-color-dark-9), var(--mantine-color-gray-0));
}
.mapka-style-editor-footer-tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--mantine-radius-md);
}
.mapka-style-editor-footer-tab-label {
  font-size: 12px;
  line-height: 1;
}
.mapka-style-editor-footer-tab-active {
  color: light-dark(white, black);
}
.mapka-style-editor-footer-tab-active .mapka-style-editor-footer-tab-icon {
  background-color: light-dark(black, white);
}
.mapka-style-editor-footer-tab-active .mapka-style-editor-footer-tab-label {
  color: light-dark(black, white);
}
`;
export const StyleEditorShell = ({ children, view, onViewChange, onNavigateBack, onSave, onPublish, onCreate, onShare, }) => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: shellStyles }), _jsxs("div", { className: "mapka-style-editor-shell", children: [_jsx("header", { className: "mapka-style-editor-shell-header", children: _jsx(StyleEditorHeader, { view: view, onViewChange: onViewChange, onNavigateBack: onNavigateBack, onSave: onSave, onPublish: onPublish, onCreate: onCreate, onShare: onShare }) }), _jsx("main", { className: "mapka-style-editor-shell-main", children: children }), _jsx("footer", { className: "mapka-style-editor-shell-footer", children: _jsx(StyleEditorFooter, { view: view, onViewChange: onViewChange }) })] })] }));
};
